export default {
	pages: {
		key: 'title',
		data: [
		]
	}
}
